import type React from "react";
import { cn } from "../utils/cn";

interface PlaybookIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  title?: string;
  dark?: boolean;
}

export function PlaybookIcon({ className, title = "Playbook Icon", dark, ...props }: PlaybookIconProps) {
  // Ensure title is never empty for accessibility
  const accessibleTitle = title || "Playbook Icon";

  return (
    <svg
      className={cn(className)}
      aria-label={accessibleTitle}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{accessibleTitle}</title>
      <path
        d="M15.4941 1.9375C16.5433 1.9375 17.3943 2.78877 17.3945 3.83789V17.1631C17.3945 18.2124 16.5435 19.0635 15.4941 19.0635H4.49414C3.4448 19.0635 2.59375 18.2124 2.59375 17.1631V3.83789C2.59401 2.78877 3.44496 1.9375 4.49414 1.9375H15.4941ZM4.49414 3.33789C4.21816 3.33789 3.9944 3.56197 3.99414 3.83789V17.1631L4.00391 17.2637C4.04379 17.4591 4.1981 17.6134 4.39355 17.6533L4.49414 17.6631H15.4941C15.7359 17.6631 15.9379 17.4916 15.9844 17.2637L15.9941 17.1631V3.83789C15.9939 3.56197 15.7701 3.33789 15.4941 3.33789H4.49414Z"
        fill={dark ? "white" : "black"}
      />
      <path
        d="M7 12.7725V10.2275C7 9.86127 7.20019 9.52434 7.52183 9.34922L9.52183 8.26034C9.81995 8.09803 10.1801 8.09803 10.4782 8.26034L12.4782 9.34922C12.7998 9.52434 13 9.86127 13 10.2275V12.7725C13 13.1387 12.7998 13.4757 12.4782 13.6508L10.4782 14.7397C10.18 14.902 9.81995 14.902 9.52183 14.7397L7.52183 13.6508C7.20019 13.4757 7 13.1387 7 12.7725Z"
        stroke={dark ? "white" : "black"}
        stroke-width="1.3"
      />
      <path d="M12 6V3H14V6L13 5L12 6Z" fill="white" />
    </svg>
  );
}

export default PlaybookIcon;
